<template>
    <div class="mb-16 mt-2">
        <div class="mb-10">
            <p class="st-dark-large">{{ $t('SET_PROFILE_DATA.WELCOME_MODAL.HEADER.TOP_P') }}</p>
            <p>{{ $t('SET_PROFILE_DATA.WELCOME_MODAL.HEADER.BOTTOM_P') }}</p>
        </div>

        <div class="py-10 w-100 profile-settings mb-4" @click="individual()">
            <div class="d-flex justify-content-between profile-settings-wrapper">
                <div>
                    <div class="item-name">{{ $t('SET_PROFILE_DATA.WELCOME_MODAL.OPTIONS.PERSON') }}</div>
                    <div>{{ $t('AUTH.REGISTER.PERSONAL_DESC') }}</div>
                </div>
                <div class="d-flex justify-content-center align-items-center">
                    <i class="fas fa-chevron-right"></i>
                </div>
            </div>
        </div>
        <div class="py-10 w-100 profile-settings mt-2" @click="juridical()">
            <div class="d-flex justify-content-between profile-settings-wrapper">
                <div>
                    <div class="item-name">{{ $t('SET_PROFILE_DATA.WELCOME_MODAL.OPTIONS.LEGAL') }}</div>
                    <div>{{ $t('AUTH.REGISTER.PROFESSIONAL_DESC') }}</div>
                </div>
                <div class="d-flex justify-content-center align-items-center">
                    <i class="fas fa-chevron-right"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'welcome-modal-page',
    data() {
        return {
            modalShow: true
        };
    },
    computed: {
        logoImage() {
            return `${process.env.BASE_URL}media/logos/logo-GU-CJCJ.png`;
        },
    },
    methods: {
        individual() {
            this.$emit('selectModal', 'citizen');
        },
        juridical() {
            this.$emit('selectModal', 'legal_entity');
        }
    },
};
</script>

<style scoped lang="scss" src="@/assets/sass/pages/home/welcome-modal.scss"></style>
